/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import {
  DirectOnrampUsersOverview,
  DirectOnrampUserDetails,
} from './components';

export const Users = () => {
  return (
    <Routes>
      <Route path="/" element={<DirectOnrampUsersOverview />} />
      <Route path="/:userId" element={<DirectOnrampUserDetails />} />
    </Routes>
  );
};
